import axios from "axios";

export const fetchOnlineUsers = (windowMinutes = 60) =>
  axios.get("/admin/presence/online", { params: { windowMinutes } });

// Compact relative-time formatter for "last move": seconds -> "acum X".
export const formatSecondsAgo = (seconds, t) => {
  const value = Math.max(0, Math.floor(Number(seconds) || 0));
  if (value < 60) return t("admin.onlineUsers.relative.justNow");
  const minutes = Math.floor(value / 60);
  if (minutes < 60) return t("admin.onlineUsers.relative.minutes", { count: minutes });
  const hours = Math.floor(minutes / 60);
  return t("admin.onlineUsers.relative.hours", { count: hours });
};
